<template>
  <img :src="logoSrc" :alt="altText" class="theme-logo" :style="logoStyle" />
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import defaultLogo from '@/assets/images/logo/kaiju-2.png'

export default {
  name: 'ThemeLogo',
  props: {
    altText: {
      type: String,
      default: 'Logo'
    },
    width: {
      type: String,
      default: null
    },
    height: {
      type: String,
      default: 'auto'
    }
  },
  computed: {
    logoSrc() {
      return this.$theme?.logo || defaultLogo
    },
    logoStyle() {
      const style = {}
      if (this.width) {
        style.width = this.width
      }
      if (this.height) {
        style.height = this.height
      }
      return style
    }
  }
}
</script>

<style scoped>
.theme-logo {
  display: block;
  object-fit: contain;
}
</style>
